import { Vue, i18n } from "Common/vue"
import AutocompleteCart from 'VueComponents/AutocompleteCart.vue';

import "../../layouts/shopping";

import "../../ui/toggle";
import "../../ui/tabs";
import './shopping-cart-jquery';

// new vue instance
window.$_autocompleteCart = new Vue({
    i18n,
    render: h => h(AutocompleteCart)
}).$mount("#autocomplete-cart");

document.addEventListener('DOMContentLoaded', function() {
    const urlString = window.location.href.toLowerCase(),
        urlObject = new URL(urlString),
        triggerImport = urlObject.searchParams.get('xlsx-import'), //xlsx
        triggerAutocomplete = urlObject.searchParams.get('quick');

    const btnImportElem = document.querySelector('.js-import-form-input'),
        autocompleteHolder = document.querySelector('.js-cart-autocomplete');

    if (btnImportElem && triggerImport) {
        setTimeout(() => {
            window.scrollTo({
                top: btnImportElem.offsetTop + btnImportElem.offsetHeight,
                behavior: 'smooth'
            });
        }, 250);
    }

    if (autocompleteHolder && triggerAutocomplete) {
        setTimeout(() => {
            window.scrollTo({
                top: autocompleteHolder.offsetTop + autocompleteHolder.offsetHeight,
                behavior: 'smooth'
            });
        }, 250);
    }
});

/**
 * Max quantity message
 */
document.addEventListener('DOMContentLoaded', function() {
    const updateQuantity = (event) => {
        const rSpinner = event.detail.rSpinner
        const quantity = rSpinner.getParsedValue()
        const oldValue = rSpinner.getParsedOldValue()
        const max = rSpinner.max
        const spinDirection = rSpinner.spinDirection

        if (quantity == oldValue && quantity == max && spinDirection == 'up' || quantity == max && spinDirection === null) {
            Eshop.tippyAlert(rSpinner.input, rSpinner.dataset.maxMessage.replaceAll(':productStock', rSpinner.max), {
                theme: 'warning'
            }, 20 * 1000);
        }
    }
    for (const rSpinner of document.querySelectorAll('r-spinner')) {
        rSpinner.addEventListener('stop', updateQuantity)
        rSpinner.addEventListener('changed', updateQuantity)
    }
});

Event.on('Cart.totals.after_updated', function(data) {
    const customTypes = [
        {
            selector: '[data-type="custom-club-discount"]',
            property: 'custom_club_discount'
        },
    ];

    for (const type of customTypes) {
        const cartElements = document.querySelectorAll(`[data-element="cart"]${type.selector}`)
        const value = data[type.property]

        for (const cartElement of cartElements) {
            const elementHolder = cartElement.closest('.js-cart-element-holder')

            if (elementHolder) {
                elementHolder.classList.toggle('hidden', value === 0)
            }

            cartElement.innerHTML = Format.price(value)
        }
    }
});

const frontendMethod = Cart.getItemsRequest
Cart.getItemsRequest = function(callback) {
    frontendMethod.call(this, (response) => {
        callback(response)

        if (response.status && response.data && response.data.items) {
            for (const item of Object.values(response.data.items)) {
                if (item.is_not_saleable) {
                    Cart.updates.product($(null), item)
                }
            }
        }
    })
}